/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-score';
const componentName = 'avi-health-score';
const prefix = `${moduleName}.${componentName}`;

export const healthBreakdownLabel = `${prefix}.healthBreakdownLabel`;
export const evaluationModeLabel = `${prefix}.evaluationModeLabel`;

export const ENGLISH = {
    [healthBreakdownLabel]: 'Health Breakdown',
    [evaluationModeLabel]: '(Evaluation)',
};
